"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOrganizationQuery = exports.useGetOrganizationSettingsQuery = void 0;

var _EmptyAppApi = require("../EmptyAppApi");

var organization = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getOrganizationSettings: build.query({
        query: function query() {
          return '/api/v1/organization/settings';
        }
      }),
      getOrganization: build.query({
        query: function query() {
          return '/api/v1/organization';
        }
      })
    };
  }
});

var useGetOrganizationSettingsQuery = organization.useGetOrganizationSettingsQuery,
    useGetOrganizationQuery = organization.useGetOrganizationQuery;
exports.useGetOrganizationQuery = useGetOrganizationQuery;
exports.useGetOrganizationSettingsQuery = useGetOrganizationSettingsQuery;